<template>
  <div>
    <general-top-bar :title="$t('reports.nexusReport')"></general-top-bar>
    <div class="sales-report">
      <div class="row mar-bt-15">
        <div class="col-md-6">
          <div class="mb-3 w-100" v-if="showLocations">
            <label class="form-label text-start w-100">{{$t('dashboard.selectLocation')}}</label>
            <select class="form-control mar-bt-15" v-model="orders.location">
              <option value="" selected :label="$t('general.all')">{{$t('general.all')}}</option>
              <option v-for="loc in locations" :key="loc.id" :label="loc.name" :value="loc.id">{{loc.name}}</option>
            </select>
          </div>

          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('general.orderId')}}</label>
            <input 
              type="number"
              min="0"
              name="price"
              placeholder="3823231"
              v-model="selectedOrderId"
              class="form-control">
          </div>

          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('nexus.nexusOrderId')}}</label>
            <input
              type="number"
              min="0"
              name="nexus_order_id"
              placeholder="12345"
              v-model="selectedNexusOrderId"
              class="form-control">
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 w-100 mar-bt-15">
            <label class="form-label text-start w-100">{{$t('catalogProd.status')}}</label>
            <v-select
              v-model="selectedType"
              :options="types"
              label="name"
              name="type-select"
              :placeholder="$t('catalogProd.status')">
            </v-select>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <p class="pull-left">
          <el-date-picker
            type="daterange"
            v-model="orders.valid"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :name="pickerNames"
            :picker-options="pickerOptions">
          </el-date-picker>
          <p class="pull-left" 
            style="display: flex;
              align-items: center;
              justify-content: center;
              margin-left: 10px;"
          >
            {{$t('general.from')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_from"
              v-model="valid_from"
              style="margin-left: 10px;"
              :change="changeValidFrom()"
              class="mar-rt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
            {{$t('general.to')}}
            <el-time-select
              :placeholder="$t('catalogProd.timePlaceholder')"
              :value="valid_to"
              v-model="valid_to"
              :change="changeValidFrom()"  
              class="mar-lt-5"
              :picker-options="{
                start: '00:00',
                step: '00:10',
                end: '24:00'
              }">
            </el-time-select>
          </p>
          <div class="pull-left search-button-reports">
            <div :title="$t('reports.search')" class="btn btn-icon btn-info btn-search" @click="updateData"><i class="ti-search"></i></div>
          </div>
          <div class="search-button-reports form-group pull-left">
            <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click="bulkUpdateStatus(0)" :title="$t('nexus.markResend')">
              <i class="ti-reload"></i>&nbsp;&nbsp;&nbsp;{{$t('nexus.markResend')}}
            </button>
          </div>
          <div class="search-button-reports form-group pull-left">
            <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" @click.prevent="bulkUpdateStatus(5)">
              <img src="/static/img/icons/icon-close.png">
              {{$t('nexus.markCancellation')}}
            </a>
            
          </div>
        </p>
      </div>
      <div class="col-md-12">
        <p style="text-align:left; margin: 20px 0px;">{{ $t('reports.filteredData') }} <b>{{orders.valid[0]}} {{valid_from}}:00</b> - <b>{{orders.valid[1]}} {{valid_to}}:00</b></p>
      </div>

      <div class="col-md-12 nexus-table-wrap" style="margin-top: 15px;">
        <div class="card-content total-pagination reports-center-columns" style="width: 100%;">
        <data-tables-server
          v-loading="loading"
          :data="ordersTableData.data"
          :search-def="{show: false}"
          @query-change="paginationChanged"
          :total="ordersTableData.total"
          :pagination-props="paginationProps"
          :table-props="{'row-class-name': rowClass}"
          class="report-sales"
          key="sales-table"
          ref="reportsTable">
            <el-table-column class-name="centered-cell" :min-width="50" prop="id" label="Id"/>
            <el-table-column class-name="centered-cell" :min-width="80" prop="order_id" :label="$t('reports.orderId')"/>
            <el-table-column class-name="centered-cell" :min-width="120" prop="location_id" :label="$t('reports.location')">
              <template slot-scope="props">
                {{ getLocationName(props.row.location_id) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="120" prop="order_created_at" :label="$t('nexus.pickupDatetime')">
              <template slot-scope="props">
                {{ props.row.order_created_at ? formatToCompanyTimezone(props.row.order_created_at, timezone) : '-' }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="100" prop="totals_grandtotal" :label="$t('reports.orderTotal')">
              <template slot-scope="props">
                {{ formatMoneyAmount(Number(props.row.totals_grandtotal || 0)) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="90" prop="payment_type" :label="$t('nexus.paymentType')">
              <template slot-scope="props">
                {{ translatePaymentType(props.row.payment_type) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="110" prop="order_status" :label="$t('nexus.orderStatus')">
              <template slot-scope="props">
                {{ translateOrderStatus(props.row.order_status) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="140" prop="is_sent" :label="$t('nexus.isSent')">
              <template slot-scope="props">
                {{ $t('nexus.sentStatus' + props.row.is_sent) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="90" prop="retry_count" :label="$t('nexus.retryCount')">
              <template slot-scope="props">
                {{ props.row.retry_count != null ? props.row.retry_count : '-' }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="120" prop="retry_at" :label="$t('nexus.retryAt')">
              <template slot-scope="props">
                {{ props.row.retry_at ? formatToCompanyTimezone(props.row.retry_at, timezone) : '-' }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="120" prop="receipt_number" :label="$t('nexus.receiptNumber')">
              <template slot-scope="props">
                {{ parseReceiptNumber(props.row.receipt_number) }}
              </template>
            </el-table-column>
            <el-table-column class-name="centered-cell" :min-width="110" prop="created_at" :label="$t('charisma.createDate')">
              <template slot-scope="props">
                {{ formatToCompanyTimezone(props.row.created_at, timezone) }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="160"
              prop="actions"
              class="align-campaign-info"
              :label="$t('marketingCampaigns.actions')">
              <template slot-scope="props">
                <div class="display-flex" style="align-items: center; margin: auto">
                  <a
                    class="btn btn-icon btn-success mar-rt-10"
                    :title="$t('nexus.markResend')"
                    @click="rowUpdateStatus(props.row.id, 0)">
                    <i class="ti-reload"></i>
                  </a>
                  <a
                    class="btn btn-icon btn-danger mar-rt-10"
                    :title="$t('nexus.markCancellation')"
                    @click="rowUpdateStatus(props.row.id, 5)">
                    <i class="ti-close"></i>
                  </a>
                  <a
                    class="btn btn-icon btn-purple"
                    :title="$t('marketingCampaigns.open')"
                    @click="goToItems(props.row)">
                    <i class="ti-angle-right"></i>
                  </a>
                </div>
              </template>
            </el-table-column>

        </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'element-ui'
import moment from 'moment'
import swal from 'sweetalert2'
import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import SearchableMultiSelect from 'src/components/UIComponents/Inputs/SearchableMultiSelect.vue'

export default {
  components: {
    GeneralTopBar,
    SearchableMultiSelect,
    [DatePicker.name]: DatePicker
  },
  props: {
    isNexusReport: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isNexusReport: {
      immediate: true,
      handler (val) {
        this.applyRouteFilters()
        this.getOrders({ page: this.paginationProps.currentPage || 1, pageSize: this.paginationProps.pageSize || 20 })
        this.verifyUserLocations()
        this.verifyUserMethods()
        this.initAdministrations()
      }
    }
  },
  created () {
    this.timezone = this.$session.get('selectedCompanyData').timezone || 'Europe/Bucharest'
    this.$bus.$on('refresh', this.handleRefresh)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  data () {
    return {
      valid_from: '05:00',
      valid_to: '05:00',
      types: [
        {id: null, name: this.$t('general.all')},
        {id: 0, name: this.$t('nexus.sentStatus0')},
        {id: 1, name: this.$t('nexus.sentStatus1')},
        {id: 2, name: this.$t('nexus.sentStatus2')},
        {id: 3, name: this.$t('nexus.sentStatus3')},
        {id: 4, name: this.$t('nexus.sentStatus4')},
        {id: 5, name: this.$t('nexus.sentStatus5')}
      ],
      selectedType: null,
      documents: [
        {id: null, name: this.$t('general.all')},
        {id: 'bill', name: this.$t('charisma.bill')},
        {id: 'invoice', name: this.$t('charisma.invoice')}
      ],
      selectedDocument: null,
      selectedSeries: null,
      selectedNumber: null,
      administrations: [],
      selectedAdministration: null,
      selectedAdministrationIdFromRoute: null,
      selectedCategories: [],
      selectedTopCategories: [],
      rawPosUsers: [],
      ordersTableData: {},
      productsTableDataTotals: {},
      selectedPosUser: null,
      loading: false,
      currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
      orders: {
        'valid': [
          moment().subtract(1, 'day').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD')
        ],
        location: '',
        method: '',
        search: ''
      },
      locations: [],
      showLocations: false,
      methods: [],
      showMethods: false,
      paginationProps: {
        layout: 'prev, pager, next, sizes, total',
        currentPage: 1,
        pageSize: 20
      },
      pickerNames: ['date_from', 'date_to'],
      pickerOptions: {
        disabledDate (date) {
          return date < moment().subtract(12, 'months').startOf('day')
        }
      },
      noData: false,
      selectedOrderId: null,
      selectedNexusOrderId: null,
      timezone: null,
      editedRowId: null
    }
  },
  methods: {
    handleRefresh (editedId) {
      if (editedId) {
        this.editedRowId = editedId
      }
      this.getOrders({
        page: this.paginationProps.currentPage || 1,
        pageSize: this.paginationProps.pageSize || 20
      })
    },
    rowClass (rowData) {
      const row = rowData.row || rowData
      const orderId = row.order_id || row.id
      return String(orderId) === String(this.editedRowId) ? 'highlight-row' : ''
    },
    getLocationName (locationId) {
      if (!locationId) return '-'
      const loc = this.locations.find(l => l.id === locationId || l.id === Number(locationId))
      return loc ? loc.name : locationId
    },
    translatePaymentType (type) {
      if (!type) return '-'
      const key = 'paymentTypes.' + type
      return this.$te(key) ? this.$t(key) : type
    },
    translateOrderStatus (status) {
      if (!status) return '-'
      const key = 'ordersStatus.' + status
      return this.$te(key) ? this.$t(key) : status
    },
    applyRouteFilters () {
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      if (q.from && q.to) {
        this.orders.valid = [q.from, q.to]
      }
      if (q.timeFrom) this.valid_from = q.timeFrom
      if (q.timeTo) this.valid_to = q.timeTo
      if (q.location) this.orders.location = q.location
      if (q.orderIdFilter) this.selectedOrderId = q.orderIdFilter
      if (q.nexusOrderIdFilter) this.selectedNexusOrderId = q.nexusOrderIdFilter
      if (q.type !== undefined) {
        const typeId = Number(q.type)
        this.selectedType = this.types.find(t => t && t.id === typeId) || null
      }
      if (q.document !== undefined) {
        this.selectedDocument = this.documents.find(d => d && d.id === q.document) || null
      }
      if (q.series !== undefined) {
        this.selectedSeries = q.series
      }
      if (q.number !== undefined) {
        this.selectedNumber = q.number ? Number(q.number) : null
      }
      if (q.admin !== undefined) {
        const adminId = Number(q.admin)
        this.selectedAdministrationIdFromRoute = adminId
        if (this.administrations && this.administrations.length > 0) {
          this.selectedAdministration = this.administrations.find(a => a && a.id === adminId) || null
          this.selectedAdministrationIdFromRoute = null
        }
      }
      if (q.page) this.paginationProps.currentPage = isNaN(q.page) ? q.page : Number(q.page)
      if (q.perPage) this.paginationProps.pageSize = isNaN(q.perPage) ? q.perPage : Number(q.perPage)
    },
    initAdministrations () {
      const sessionData = this.$session.get('selectedCompanyData') || {}
      if (sessionData['administrations']) {
        this.administrations = sessionData['administrations']
        if (this.selectedAdministrationIdFromRoute && !this.selectedAdministration) {
          this.selectedAdministration = this.administrations.find(a => a && a.id === Number(this.selectedAdministrationIdFromRoute)) || null
          this.selectedAdministrationIdFromRoute = null
        }
        return
      }
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/administration', 'GET', data, (response) => {
        if (response && response.status && Array.isArray(response.data)) {
          this.administrations = response.data
          sessionData['administrations'] = response.data
          this.$session.set('selectedCompanyData', sessionData)
          if (this.selectedAdministrationIdFromRoute && !this.selectedAdministration) {
            this.selectedAdministration = this.administrations.find(a => a && a.id === Number(this.selectedAdministrationIdFromRoute)) || null
            this.selectedAdministrationIdFromRoute = null
          }
        } else {
          this.administrations = []
        }
      })
    },
    goToItems (row) {
      const orderId = row.order_id || row.id
      if (!orderId) { return }
      const page = this.paginationProps.currentPage || 1
      const perPage = this.paginationProps.pageSize || 20
      const query = {
        tab: 'nexus',
        page,
        perPage,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      }
      if (this.orders.location) query.location = this.orders.location
      if (this.selectedOrderId) query.orderIdFilter = this.selectedOrderId
      if (this.selectedNexusOrderId) query.nexusOrderIdFilter = this.selectedNexusOrderId
      if (this.selectedType) query.type = this.selectedType.id ? this.selectedType.id : this.selectedType
      if (this.selectedDocument) query.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument
      if (this.selectedSeries) query.series = this.selectedSeries
      if (this.selectedNumber) query.number = this.selectedNumber
      if (this.selectedAdministration) query.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration
      this.$router.push({
        name: 'Nexus Items',
        params: { orderId: String(orderId) },
        query
      })
    },
    changeValidFrom () {
      if (!this.valid_from) {
        this.valid_from = '00:00'
      }
      if (!this.valid_to) {
        this.valid_to = '23:59'
      }
    },
    paginationChanged (query) {
      if (query.type === 'page' || query.type === 'size' || query.type === 'sort') {
        const pageSize = query.pageSize || this.paginationProps.pageSize || 20
        const page = query.page || this.paginationProps.currentPage || 1
        const syncQuery = Object.assign({}, this.$route.query, {
          tab: 'nexus',
          page,
          perPage: pageSize,
          from: this.orders.valid[0],
          to: this.orders.valid[1],
          timeFrom: this.valid_from,
          timeTo: this.valid_to
        })
        if (this.orders.location) syncQuery.location = this.orders.location
        if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId
        if (this.selectedNexusOrderId) syncQuery.nexusOrderIdFilter = this.selectedNexusOrderId
        if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType
        if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument
        if (this.selectedSeries) syncQuery.series = this.selectedSeries
        if (this.selectedNumber) syncQuery.number = this.selectedNumber
        if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration
        this.$router.replace({ path: '/reports', query: syncQuery })
        this.getOrders(query)
      }
    },
    verifyUserLocations () {
      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      if (!this.isOwner()) {
        let allowedLocations = JSON.parse(this.$session.get('userDataLocations'))

        if (allowedLocations.length === 0) {
          this.showLocations = true
          this.locations.forEach((element) => {
            allowedLocations.push(element.id)
          })
        }

        this.locations = this.locations.filter(function (el) {
          return allowedLocations.includes(el.id)
        })
      }

      if (this.locations.length > 1) {
        this.showLocations = true
      }

      let filterCookie = this.$cookie.get('filter-locations')
      if (filterCookie) {
        filterCookie = JSON.parse(filterCookie)
        this.orders.location = filterCookie[0]
      }
    },
    verifyUserMethods () {
      this.methods = this.$session.get('selectedCompanyData').delivery_options_labels
      this.showMethods = true
    },
    getOrders (query) {
      if (!this.isNexusReport) {
        return
      }
      if (this.valid_to === '24:00') {
        this.valid_to = '23:59'
      }
      if (this.valid_from === '24:00') {
        this.valid_from = '23:59'
      }

      let fromDate = this.orders.valid[0] + ' ' + this.valid_from + ':00'
      let toDate = this.orders.valid[1] + ' ' + this.valid_to + ':00'

      let data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }

      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId
      }

      if (this.selectedNexusOrderId) {
        data.nexus_order_id = this.selectedNexusOrderId
      }

      if (this.selectedType) {
        data.status = this.selectedType.id
      }

      if (this.selectedDocument) {
        data.document = this.selectedDocument.id
      }

      if (this.selectedSeries) {
        data.series = this.selectedSeries
      }

      if (this.selectedNumber) {
        data.number = this.selectedNumber
      }

      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id
      }

      this.loading = true
      const pageSize = (query && query.pageSize) ? query.pageSize : (this.paginationProps.pageSize || 20)
      const page = (query && query.page) ? query.page : (this.paginationProps.currentPage || 1)

      this.apiRequest('/nexus/report' + '?page=' + page + '&perPage=' + pageSize, 'GET', data, response => {
        if (response.status) {
          if (response.data.table_data.length) {
            this.ordersTableData = {
              data: response.data.table_data,
              total: response.pagination.total
            }
            this.paginationProps.currentPage = response.pagination.page
            this.paginationProps.pageSize = response.pagination.perPage
          } else {
            this.ordersTableData = { data: [], total: 0 }
            this.paginationProps.currentPage = 1
            this.paginationProps.pageSize = 20
          }

          this.noData = false
        } else {
          this.discounts = []
          this.noData = true

          swal(
            '',
            response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }

        this.$nextTick(() => {
          this.loading = false
          if (this.editedRowId) {
            const highlighted = this.$el.querySelector('.el-table__body tr.highlight-row')
            if (highlighted) {
              highlighted.scrollIntoView({ block: 'center', behavior: 'smooth' })
            }
          }
        })
      })
    },
    rowUpdateStatus (nexusOrderId, newStatus) {
      const titleKey = newStatus === 0 ? 'nexus.markResend' : 'nexus.markCancellation'
      const confirmText = newStatus === 0
        ? `${this.$t('nexus.markResendConfirm')} (#${nexusOrderId})`
        : `${this.$t('nexus.markCancellationConfirm')} (#${nexusOrderId})`
      swal({
        title: this.$t(titleKey),
        text: confirmText,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('general.cancel') || 'Cancel'
      }).then(result => {
        if (!result) return
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          nexus_order_id: nexusOrderId,
          new_status: newStatus
        }
        this.loading = true
        this.apiRequest('/nexus/bulk-update-status', 'POST', data, (response) => {
          if (response && response.status) {
            swal('', this.$t('nexus.markSuccessMessage'), 'success')
            this.getOrders({ page: this.paginationProps.currentPage || 1, pageSize: this.paginationProps.pageSize || 20 })
          } else {
            swal(
              '',
              response && response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
              'error'
            )
          }
          this.$nextTick(() => { this.loading = false })
        })
      })
    },
    bulkUpdateStatus (newStatus) {
      const confirmKey = newStatus === 0 ? 'nexus.markResendConfirm' : 'nexus.markCancellationConfirm'
      const titleKey = newStatus === 0 ? 'nexus.markResend' : 'nexus.markCancellation'
      swal({
        title: this.$t(titleKey),
        text: this.$t(confirmKey),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('general.cancel') || 'Cancel'
      }).then(result => {
        if (!result) return
        this._doBulkUpdateStatus(newStatus)
      })
    },
    _doBulkUpdateStatus (newStatus) {
      if (this.valid_to === '24:00') this.valid_to = '23:59'
      if (this.valid_from === '24:00') this.valid_from = '23:59'

      const fromDate = this.orders.valid[0] + ' ' + this.valid_from + ':00'
      const toDate = this.orders.valid[1] + ' ' + this.valid_to + ':00'

      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        from_date: fromDate,
        to_date: toDate,
        new_status: newStatus
      }

      if (this.orders.location && this.orders.location !== '') {
        data.location_id = this.orders.location
      }
      if (this.selectedOrderId) {
        data.order_id = this.selectedOrderId
      }
      if (this.selectedNexusOrderId) {
        data.nexus_order_id = this.selectedNexusOrderId
      }
      if (this.selectedType) {
        data.status = this.selectedType.id
      }
      if (this.selectedDocument) {
        data.document = this.selectedDocument.id
      }
      if (this.selectedSeries) {
        data.series = this.selectedSeries
      }
      if (this.selectedNumber) {
        data.number = this.selectedNumber
      }
      if (this.selectedAdministration) {
        data.administration_id = this.selectedAdministration.id
      }

      this.loading = true
      this.apiRequest('/nexus/bulk-update-status', 'POST', data, (response) => {
        if (response && response.status) {
          swal('', this.$t('nexus.markSuccessMessage'), 'success')
          this.getOrders({ page: this.paginationProps.currentPage || 1, pageSize: this.paginationProps.pageSize || 20 })
        } else {
          swal(
            '',
            response && response.errors && response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
            'error'
          )
        }
        this.$nextTick(() => { this.loading = false })
      })
    },
    sentStatusClass (status) {
      const map = {
        0: 'text-muted',    // Pending
        1: 'text-success',  // Sent successfully
        2: 'text-danger',   // Permanently failed
        3: 'text-info',     // Cancellation confirmed
        4: 'text-warning',  // Retry scheduled
        5: 'text-warning'   // Pending cancellation
      }
      return map[status] !== undefined ? map[status] : 'text-muted'
    },
    parseReceiptNumber (raw) {
      if (!raw) return '-'
      try {
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        const num = parsed.ReceiptNumber
        const status = parsed.ReceiptStatus
        if (num !== undefined && num !== null) {
          return status === false ? `${num} (error)` : num
        }
        return raw
      } catch (e) {
        return raw
      }
    },
    updateData () {
      const syncQuery = Object.assign({}, this.$route.query, {
        tab: 'nexus',
        page: this.paginationProps.currentPage || 1,
        perPage: this.paginationProps.pageSize || 20,
        from: this.orders.valid[0],
        to: this.orders.valid[1],
        timeFrom: this.valid_from,
        timeTo: this.valid_to
      })
      if (this.orders.location) syncQuery.location = this.orders.location
      if (this.selectedOrderId) syncQuery.orderIdFilter = this.selectedOrderId
      if (this.selectedNexusOrderId) syncQuery.nexusOrderIdFilter = this.selectedNexusOrderId
      if (this.selectedType) syncQuery.type = this.selectedType.id ? this.selectedType.id : this.selectedType
      if (this.selectedDocument) syncQuery.document = this.selectedDocument.id ? this.selectedDocument.id : this.selectedDocument
      if (this.selectedSeries) syncQuery.series = this.selectedSeries
      if (this.selectedNumber) syncQuery.number = this.selectedNumber
      if (this.selectedAdministration) syncQuery.admin = this.selectedAdministration.id ? this.selectedAdministration.id : this.selectedAdministration
      this.$router.replace({ path: '/reports', query: syncQuery })
      this.getOrders({ page: syncQuery.page, pageSize: syncQuery.perPage })
      this.$cookie.set('filter-locations', JSON.stringify([this.orders.location]), 30)
    }
  }
}
</script>
<style>
  .ct-label {
    display: none;
  }
  .ct-legend-inside .inactive {
    opacity: 0.3;
  }
  .cell b {
    word-break: break-word;
  }
  .card .details h6 {
    text-align: left;
    font-weight: 500;
  }
  .report-container {
    display: flex;
    flex-direction: column;
    background: #FBFCFF;
    border-radius: 11px;
    padding: 70px;
  }
  .report-row slim {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
  }
  .sales-report .sales-height .card {
    min-height: 500px;
    display: flex;
    justify-content: center;
  }
  .sales-report .sales-height:nth-child(1) .card {
    align-items: center;
  }
  .center-sales-report-stats .card-content{
    max-width: 800px;
    width: 650px;
  }
  .report-col {
    flex: 1;
    padding: 0 10px;
  }
  .report-col:nth-child(1){
    color: #25396F;
    font-size: 18px;
    font-weight: 500;
  }
  .ct-label.ct-horizontal {
    font-size: 12px !important;
    text-anchor: middle !important;
  }
  foreignObject div {
    font-size: 12px;
    line-height: 1.2em;
    text-align: center;
    color: #333;
  }

  .ct-label .ct-vertical {
    font-size: 12px;
    overflow: visible !important;
  }

  .ct-chart {
    padding-top: 20px;
    overflow: visible !important;
  }

  .slim {
    margin-bottom: 10px !important;
  }
  .nexus-table-wrap .el-table__body-wrapper {
    overflow-x: auto !important;
  }
  .nexus-table-wrap .el-table__header table,
  .nexus-table-wrap .el-table__body table {
    min-width: 1520px;
  }
  .nexus-table-wrap .btn-icon {
    width: 30px !important;
    height: 30px !important;
    min-width: 30px !important;
    padding: 0 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 13px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reports/Versions/2/NexusReport.vue